<template>
  <div id="app">
    <loading :isShow="showOrNot" />
    <page-kv :isShow="showOrNot" @playVideo="handleVideo" @goOnPlay="handlePlay" @gogame="entergame" @toggleBgm="handleBgm" />
    <!-- <page-one :isShow="showOrNot" :videoState="isPlayVideo" @goOnPlay="handlePlay" @hvDirective="hvPlay" @gogame="entergame" @toggleBgm="handleBgm" /> -->
    <page-two :isShow="showOrNot" :submainstagestate="mainstagestate" />
    <page-three :isShow="showOrNot" />
    <music-player :isShow="showOrNot" :bNum="bgmNum" :pState="playState" />
    <rotate-it />
    
  </div>
</template>

<script>
import Loading from './pages/loading/loading'
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import PageKV from './pages/page-kv/pageKV'
// import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'
import PageThree from './pages/page-three/pageThree'

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    // 'page-one': PageOne,
    'page-two': PageTwo,
    'page-three': PageThree,
    'page-kv': PageKV
  },
  data () {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isPRShow: false
      },
      isPlayVideo: false,
      
      mainstagestate:false,
      bgmNum: 0,
      playState: true,
      
    }
  },
  methods: {
    handleVideo () {
      this.isPlayVideo = true
    },
    handleBgm (msg) {
      console.log('msg: ' + msg)
      this.bgmNum = msg
    },
    handlePlay () {
      this.playState = !this.playState
    },
    entergame(){
      this.mainstagestate=true
    }
  },
  mounted () {
    
  },
  created () {
    // const _this = this
    // const pre = process.env.NODE_ENV === 'development' ? '' : 'https://www.jiandoukeji.com'
    // const authURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd425e46955d31e8e&redirect_uri=http%3a%2f%2fwww.jiandoukeji.com%2fcodes%2f2018%2faudizq%2fgame.php%2fHome%2fWxwx%2f&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirec'
    // const reqURL = 'https://www.jiandoukeji.com/codes/2018/audizq/game.php/Home/Index/JDOU_whoyouare/'
    // $.ajax({
    //   url: reqURL,
    //   type: 'POST',
    //   dataType: 'json',
    //   success: function (res) {
    //     if (res.status === 0) {
    //       window.location.href = authURL
    //     } else {

    //     }
    //   }
    // })
  },
}
</script>

<style>
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>